// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ct-export-catalog-step .export-catalog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4rem;
}
.ct-export-catalog-step .export-catalog-content .export-catalog-instructions {
  display: flex;
  flex-direction: column;
  width: 60%;
  text-align: center;
}
.ct-export-catalog-step .export-catalog-content .export-catalog-button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.5rem;
}
.ct-export-catalog-step .export-catalog-content .export-catalog-button-container .export-catalog-count {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bolder;
}
.ct-export-catalog-step .export-catalog-content .export-catalog-button-container .export-catalog-count div {
  font-weight: bolder;
}
.ct-export-catalog-step .export-catalog-content .export-catalog-button-container .button-component {
  min-width: 30rem;
}

.popup-component:has(> .confirmation-popup.export-complete-modal) {
  width: 75rem;
}

.export-complete-modal h3 {
  font-size: 3.6rem;
}
.export-complete-modal .export-complete-copy div {
  margin-bottom: 2rem;
}
.export-complete-modal .export-complete-copy .export-complete-header {
  font-size: 2.8rem;
}
.export-complete-modal .buttons {
  justify-content: flex-end;
}
.export-complete-modal .buttons .button-component:first-child {
  justify-content: end;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/ExportCatalogStep/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAAJ;AAEI;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AADN;AAGM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AADR;AAGQ;EACE,mBAAA;AADV;AAKM;EACE,gBAAA;AAHR;;AAUA;EACE,YAAA;AAPF;;AAYE;EACE,iBAAA;AATJ;AAaI;EACE,mBAAA;AAXN;AAcI;EACE,iBAAA;AAZN;AAgBE;EACE,yBAAA;AAdJ;AAgBI;EACE,oBAAA;AAdN","sourcesContent":[".ct-export-catalog-step {\n  .export-catalog-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4rem;\n\n    .export-catalog-instructions {\n      display: flex;\n      flex-direction: column;\n      width: 60%;\n      text-align: center;\n    }\n\n    .export-catalog-button-container {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 2.5rem;\n\n      .export-catalog-count {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        font-weight: bolder;\n\n        div {\n          font-weight: bolder;\n        }\n      }\n\n      .button-component {\n        min-width: 30rem;\n      }\n    }\n  }\n}\n\n// Parent styling when export-complete-modal is present\n.popup-component:has(> .confirmation-popup.export-complete-modal) {\n  width: 75rem;\n}\n\n// Export Complete Modal Styles\n.export-complete-modal {\n  h3 {\n    font-size: 3.6rem;\n  }\n\n  .export-complete-copy {\n    div {\n      margin-bottom: 2rem;\n    }\n\n    .export-complete-header {\n      font-size: 2.8rem;\n    }\n  }\n\n  .buttons {\n    justify-content: flex-end;\n\n    .button-component:first-child {\n      justify-content: end;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
